// extracted by mini-css-extract-plugin
module.exports = {"closePage":"ClosePage_closePage__2RgSN"};